import { gql } from 'graphql-tag'
import { fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'

export default gql`
    ${fragmentModuleMedia}
    fragment PaymentsPaymentMethodFragment on PaymentsPaymentMethod {
        sys {
            id
        }
        name
        submethodsTitle
        submethodCollection(limit: 3) {
            items {
                sys {
                    id
                }
                name
                shortDescription
                description {
                    json
                }
                image {
                    ...ModuleMediaFragment
                }
            }
        }
        shortDescription
        description {
            json
        }
        image {
            ...ModuleMediaFragment
        }
        paymentMethodTypeCollection(limit: 3) {
            items {
                sys {
                    id
                }
                name
                icon
            }
        }
        settlementCurrencyAll
        settlementCurrencyInfo
        refunds
        refundsInfo
        partialRefunds
        partialRefundsInfo
        multiplePartialRefunds
        multiplePartialRefundsInfo
        multiplePartialCaptures
        multiplePartialCapturesInfo
        secure3D
        secure3DInfo
        chargeback
        chargebackInfo
        entityRequired
        entityRequiredInfo
        salesDayPayout
        salesDayPayoutInfo
        settlementDelay
        recurring
        recurringInfo
    }
`
